import { BaseResponse } from './internal/baseresponse';
export class VersionModifyResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/versionmodifyresult.ts